module.exports = __webpack_public_path__ + "static/img/android-icon.03d4d76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/nav/images/android-icon.svg
// module id = V49M
// module chunks = 12